/**
 * Laengengrenze fuer den Empfaengernamen einer Lieferadresse.
 *
 * Der Name ist ein freies Feld: dort steht mal ein Angehoeriger, mal ein Pflegeheim, mal das
 * Sanitaetshaus selbst. Weicht er vom Patientennamen ab, reicht das Backend ihn als `c/o <Name>`
 * an den Logistiker durch (Hartmann: `PartnerName2`, Sabeda: `careOf`, Nonne: `name_2`).
 *
 * Der engste Empfaenger ist Hartmann mit 35 Zeichen im dahinterliegenden SAP-Feld `NAME2` (Nonne
 * kappt bei 40, Sabeda und TZMO nennen keine Grenze). Von diesen 35 verbraucht unser Praefix
 * `c/o ` bereits vier, uebrig bleiben also {@link EMPFAENGERNAME_MAX_LAENGE} Zeichen fuer die
 * Eingabe. Was darueber steht, kuerzt Hartmann beim Einlesen still weg. Die Bestellung laeuft
 * trotzdem durch, nur steht auf dem Paket dann ein halber Name.
 *
 * Bewusst eine Warnung und keine Validierung: die Grenze gilt nur fuer einen Teil der Logistiker,
 * und ein Formular, das eine korrekte Adresse ablehnt, ist schlimmer als ein gekuerzter Aufkleber.
 */
export const EMPFAENGERNAME_MAX_LAENGE = 31

/** Text der Warnung. Steht hier, damit alle vier Eingabemasken denselben Satz zeigen. */
export const EMPFAENGERNAME_ZU_LANG_HINWEIS = `Dieser Name ist länger als ${EMPFAENGERNAME_MAX_LAENGE} Zeichen. Manche Logistiker kürzen ihn dann auf dem Paketaufkleber.`

/**
 * Ob der eingegebene Empfaengername beim Logistiker gekuerzt werden koennte.
 *
 * Gemessen wird der getrimmte Wert, weil das Backend den Namen ebenfalls getrimmt weitergibt.
 */
export function istEmpfaengernameZuLang(name: string | null | undefined): boolean {
  return (name?.trim().length ?? 0) > EMPFAENGERNAME_MAX_LAENGE
}
